/* eslint-disable camelcase */
export const AGENT_BG = 'agent-val-bg.jpg';
export const INSTANT_BG = 'nosy-neighbour.jpg';

export const BASE_URL = 'https://storage.googleapis.com/assets.propertypal.com/valuation-backgrounds/';

export const POSTCODE_MOB_IMAGES: { [key: string]: string } = {
  bt1: 'BT1-mob.jpg',
  bt2: 'BT2-mob.jpg',
  bt3: 'BT3-mob.jpg',
  bt4: 'BT4-mob.jpg',
  bt5: 'BT5-6-mob.jpg',
  bt6: 'BT5-6-mob.jpg',
  bt7: 'BT7-mob.jpg',
  bt8: 'BT8-9-10-mob.jpg',
  bt9: 'BT8-9-10-mob.jpg',
  bt10: 'BT8-9-10-mob.jpg',
  bt11: 'BT11-12-13-17-mob.jpg',
  bt12: 'BT11-12-13-17-mob.jpg',
  bt13: 'BT11-12-13-17-mob.jpg',
  bt14: 'BT14-mob.jpg',
  bt15: 'BT15-mob.jpg',
  bt16: 'BT16-mob.jpg',
  bt17: 'BT11-12-13-17-mob.jpg',
  bt18: 'BT18-mob.jpg',
  bt19: 'BT19-mob.jpg',
  bt20: 'BT20-mob.jpg',
  bt21: 'BT21-mob.jpg',
  bt22: 'BT22-mob.jpg',
  bt23: 'BT23-mob.jpg',
  bt24: 'BT24-mob.jpg',
  bt25: 'BT25-mob.jpg',
  bt26: 'BT26-mob.jpg',
  bt27: 'BT27-mob.jpg',
  bt28: 'BT28-mob.jpg',
  bt29: 'BT29-mob.jpg',
  bt30: 'BT30-mob.jpg',
  bt31: 'BT31-mob.jpg',
  bt32: 'BT32-mob.jpg',
  bt33: 'BT33-mob.jpg',
  bt34: 'BT34-mob.jpg',
  bt35: 'BT35-mob.jpg',
  bt36: 'BT36-37-58-mob.jpg',
  bt37: 'BT36-37-58-mob.jpg',
  bt38: 'BT38-mob.jpg',
  bt39: 'BT39-mob.jpg',
  bt40: 'BT40-mob.jpg',
  bt41: 'BT41-mob.jpg',
  bt42: 'BT42-mob.jpg',
  bt43: 'BT43-44-mob.jpg',
  bt44: 'BT43-44-mob.jpg',
  bt45: 'BT45-mob.jpg',
  bt46: 'BT46-mob.jpg',
  bt47: 'BT47-48-mob.jpg',
  bt48: 'BT47-48-mob.jpg',
  bt49: 'BT49-mob.jpg',
  bt51: 'BT51-mob.jpg',
  bt52: 'BT52-mob.jpg',
  bt53: 'BT53-mob.jpg',
  bt54: 'BT54-mob.jpg',
  bt55: 'BT55-mob.jpg',
  bt56: 'BT56-mob.jpg',
  bt57: 'BT57-mob.jpg',
  bt58: 'BT36-37-58-mob.jpg',
  bt60: 'BT60-mob.jpg',
  bt61: 'BT61-mob.jpg',
  bt62: 'BT62-67-mob.jpg',
  bt63: 'BT62-67-mob.jpg',
  bt64: 'BT62-67-mob.jpg',
  bt65: 'BT62-67-mob.jpg',
  bt66: 'BT62-67-mob.jpg',
  bt67: 'BT62-67-mob.jpg',
  bt68: 'BT68-69-70-71-mob.jpg',
  bt69: 'BT68-69-70-71-mob.jpg',
  bt70: 'BT68-69-70-71-mob.jpg',
  bt71: 'BT68-69-70-71-mob.jpg',
  bt74: 'BT74-mob.jpg',
  bt75: 'BT75-76-77-mob.jpg',
  bt76: 'BT75-76-77-mob.jpg',
  bt77: 'BT75-76-77-mob.jpg',
  bt78: 'BT78-mob.jpg',
  bt79: 'BT79-mob.jpg',
  bt80: 'BT80-mob.jpg',
  bt81: 'BT81-82-mob.jpg',
  bt82: 'BT81-82-mob.jpg',
  bt92: 'BT92-mob.jpg',
  bt93: 'BT93-94-mob.jpg',
  bt94: 'BT93-94-mob.jpg',
};

export const POSTCODE_IMAGES: { [key: string]: string } = {
  bt1: 'BT1.jpg',
  bt2: 'BT2.jpg',
  bt3: 'BT3.jpg',
  bt4: 'BT4.jpg',
  bt5: 'BT5-6.jpg',
  bt6: 'BT5-6.jpg',
  bt7: 'BT7.jpg',
  bt8: 'BT8-9-10.jpg',
  bt9: 'BT8-9-10.jpg',
  bt10: 'BT8-9-10.jpg',
  bt11: 'BT11-12-13-17.jpg',
  bt12: 'BT11-12-13-17.jpg',
  bt13: 'BT11-12-13-17.jpg',
  bt14: 'BT14.jpg',
  bt15: 'BT15.jpg',
  bt16: 'BT16.jpg',
  bt17: 'BT11-12-13-17.jpg',
  bt18: 'BT18.jpg',
  bt19: 'BT19.jpg',
  bt20: 'BT20.jpg',
  bt21: 'BT21.jpg',
  bt22: 'BT22.jpg',
  bt23: 'BT23.jpg',
  bt24: 'BT24.jpg',
  bt25: 'BT25.jpg',
  bt26: 'BT26.jpg',
  bt27: 'BT27.jpg',
  bt28: 'BT28.jpg',
  bt29: 'BT29.jpg',
  bt30: 'BT30.jpg',
  bt31: 'BT31.jpg',
  bt32: 'BT32.jpg',
  bt33: 'BT33.jpg',
  bt34: 'BT34.jpg',
  bt35: 'BT35.jpg',
  bt36: 'BT36-37-58.jpg',
  bt37: 'BT36-37-58.jpg',
  bt38: 'BT38.jpg',
  bt39: 'BT39.jpg',
  bt40: 'BT40.jpg',
  bt41: 'BT41.jpg',
  bt42: 'BT42.jpg',
  bt43: 'BT43-44.jpg',
  bt44: 'BT43-44.jpg',
  bt45: 'BT45.jpg',
  bt46: 'BT46.jpg',
  bt47: 'BT47-48.jpg',
  bt48: 'BT47-48.jpg',
  bt49: 'BT49.jpg',
  bt51: 'BT51.jpg',
  bt52: 'BT52.jpg',
  bt53: 'BT53.jpg',
  bt54: 'BT54.jpg',
  bt55: 'BT55.jpg',
  bt56: 'BT56.jpg',
  bt57: 'BT57.jpg',
  bt58: 'BT36-37-58.jpg',
  bt60: 'BT60.jpg',
  bt61: 'BT61.jpg',
  bt62: 'BT62-67.jpg',
  bt63: 'BT62-67.jpg',
  bt64: 'BT62-67.jpg',
  bt65: 'BT62-67.jpg',
  bt66: 'BT62-67.jpg',
  bt67: 'BT62-67.jpg',
  bt68: 'BT68-69-70-71.jpg',
  bt69: 'BT68-69-70-71.jpg',
  bt70: 'BT68-69-70-71.jpg',
  bt71: 'BT68-69-70-71.jpg',
  bt74: 'BT74.jpg',
  bt75: 'BT75-76-77.jpg',
  bt76: 'BT75-76-77.jpg',
  bt77: 'BT75-76-77.jpg',
  bt78: 'BT78.jpg',
  bt79: 'BT79.jpg',
  bt80: 'BT80.jpg',
  bt81: 'BT81-82.jpg',
  bt82: 'BT81-82.jpg',
  bt92: 'BT92.jpg',
  bt93: 'BT93-94.jpg',
  bt94: 'BT93-94.jpg',
};
